import React,{useEffect} from 'react'
import CardAvatar from '../../components/CardAvatar'
import alexAvatar from '../../assets/alessandro-linkedlin-avatar.jpeg'
import valentinoAvatar from '../../assets/valentino-avatar.jpeg'
import eddyAvatar from '../../assets/eddyAvatar.jpeg'
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


const ReferenceSection = React.forwardRef((props , ref) => {

    useEffect(()=>{
        gsap.registerPlugin(ScrollTrigger);
        gsap.fromTo('.section-title-reference',
             {opacity: 0, y: -50}, 
             {opacity: 1, y: 0, duration: 1, ease: 'power2.out', 
                scrollTrigger: {trigger: '.section-title-reference',
                     start: 'top 80%', toggleActions: 'play none none none'
                    }
                }
            );
            console.log(ref)
   
    },[ref])


  return (


    <div ref={ref}  className='container-fluid bg-light p-md-0 py-5 m-0 position-relative'>
     <h1 className='section-title-reference ms-md-5 py-md-5 p-0  ms-1 text-break'>Testimonials </h1>
     <div className='container '>
          <div  className="row min-height-100-y align-items-center justify-content-center ">

             <CardAvatar className='col-md-12 col-lg-4  mt-4' title="Software Developer" name="Alessandro Marletta" description="Ho avuto il piacere di collaborare con Mario per un periodo di tempo significativo e posso confermare che è un talentuoso sviluppatore front-end, sempre desideroso di apprendere e con una passione innata per il suo lavoro. Mario si distingue soprattutto per la sua abilità nel design delle applicazioni, creando mockup eccezionali e interpretando i requisiti dei clienti con grande precisione e attenzione meticolosa ai dettagli" image={alexAvatar} />
           
             <CardAvatar className='col-md-12 col-lg-4 mt-4' title="Freelance Mobile Developer ..." name="Valentino Romano" description="Mario è un vulcano, un imprenditore nato, pronto a dare il meglio di se in ogni situazione.

                    Persona molto capace in ogni campo, ama le cose fatte bene, è un perfezionista. 

                    Bellissimo carattere, umile, preferisce fa vedere cosa da fare piuttosto che vantarsi a parole. 

                    Sa fare gioco di squadra o lavorare da solo, la sua voglia di migliorare lo galvanizza e poi è contagiosa. 

                    Ancora un po’ inesperto non tanto nel lavoro (ci sta, è ancora un giovane developer in cerca di fama 😂) ma in quelle situazioni dove si deve prendere la decisione giusta. 

                    Avvolte sotto stress perde la concentrazione, chi non la fa, ma è solo questione di tempo ed esperienza, la sua tenacia e la sua resilienza ai problemi gli faranno superare ogni ostacolo così come fa nella vita di tutti i giorni. 

                    Da vita a soluzioni semplici ma efficaci, sa organizzarsi il lavoro da solo, sa come studiare una libreria o un nuovo linguaggio di programmazione. 

                    Le sue capacità di Dev non sono mai in discussione, lo giudico un Middle non uno Junior. 

                    Poliedrico, sa quello che vuole e cosa gli piace. 

                    Aperto a consigli e feedback anche a critiche che sfrutta per migliorare. 

                    Peccato non avere più una società, sarebbe stato un ottimo elemento nel team, la punta di diamante. "
                    
                     image={valentinoAvatar} />

            <CardAvatar className='col-md-12 col-lg-4 mt-4' title="Sviluppatore Angular" name="Edmondo Domenico Lopez" description="Mario è un giovane talento dell'informatica dalla grande curiosità, capace di espandere in fretta le prorie conoscenze per metterle in pratica nel proprio lavoro. Quando lo si vede lavorare traspare tutta la passione che ha per la programmazione, una volta che avrà accumulato la giusta esperienza sul campo sono certo che potrà sviluppare progetti molto validi." image={eddyAvatar} />
        </div> 
     </div>
     

    </div>
  )
})

export default ReferenceSection